class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    if (this.dataset.openOnHover !== undefined) {
      this.summary = this.mainDetailsToggle.querySelector('summary');
      this.hoverMedia = window.matchMedia('(hover: hover) and (min-width: 990px)');
      this.addEventListener('pointerenter', this.openOnHover.bind(this));
      this.addEventListener('pointerleave', this.closeOnHover.bind(this));
      this.addEventListener('focusin', this.openOnFocus.bind(this));
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  openOnHover() {
    if (!this.hoverMedia.matches) return;
    window.clearTimeout(this.closeTimeout);
    this.closeSiblingMenus();
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  closeOnHover() {
    if (!this.hoverMedia.matches) return;
    this.closeTimeout = window.setTimeout(() => {
      if (this.matches(':hover') || this.contains(document.activeElement)) return;
      this.close();
    }, 120);
  }

  openOnFocus() {
    if (!this.hoverMedia.matches) return;
    this.closeSiblingMenus();
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  closeSiblingMenus() {
    document.querySelectorAll('header-menu[data-open-on-hover]').forEach((menu) => {
      if (menu === this) return;
      menu.close();
    });
  }
}

customElements.define('header-menu', HeaderMenu);
